module.exports = __webpack_public_path__ + "static/img/rotation.08616856.png";